export default "__VITE_ASSET__arAX4Oau__"